export enum ToastyEnum {
  Success = 'toasty-success',
  Error = 'toasty-error',
  Warning = 'toasty-warning',
  Info = 'toasty-info'
}
